const ENDPOINTS = {
  GET_READ_TOKEN: '/get_read_token',
  GET_READ_WRITE_TOKEN: '/get_readwrite_token',
};

export default ENDPOINTS;
